export interface IKey {
    key: string,
    value: string,
    misc: string
}

export class Keys {


    static stateList: IKey[] = [
        { key: 'AL', value: 'Alabama', misc: '' },
        { key: 'AK', value: 'Alaska', misc: '' },
        { key: 'AZ', value: 'Arizona', misc: '' },
        { key: 'AR', value: 'Arkansas', misc: '' },
        { key: 'CA', value: 'California', misc: '' },
        { key: 'CO', value: 'Colorado', misc: '' },
        { key: 'CT', value: 'Connecticut', misc: '' },
        { key: 'DE', value: 'Deleware', misc: '' },
        { key: 'FL', value: 'Florida', misc: '' },
        { key: 'GA', value: 'Georgia', misc: '' },
        { key: 'HI', value: 'Hawaii', misc: '' },
        { key: 'ID', value: 'Idaho', misc: '' },
        { key: 'IL', value: 'Illinois', misc: '' },
        { key: 'IN', value: 'Indiana', misc: '' },
        { key: 'IA', value: 'Iowa', misc: '' },
        { key: 'KS', value: 'Kansas', misc: '' },
        { key: 'KY', value: 'Kentucky', misc: '' },
        { key: 'LA', value: 'Louisiana', misc: '' },
        { key: 'ME', value: 'Maine', misc: '' },
        { key: 'MD', value: 'Maryland', misc: '' },
        { key: 'MA', value: 'Massachusetts', misc: '' },
        { key: 'MI', value: 'Michigan', misc: '' },
        { key: 'MN', value: 'Minnesota', misc: '' },
        { key: 'MS', value: 'Mississippi', misc: '' },
        { key: 'MO', value: 'Missouri', misc: '' },
        { key: 'MT', value: 'Montana', misc: '' },
        { key: 'NE', value: 'Nebraska', misc: '' },
        { key: 'NV', value: 'Nevada', misc: '' },
        { key: 'NH', value: 'New Hampshire', misc: '' },
        { key: 'NJ', value: 'New Jersey', misc: '' },
        { key: 'NM', value: 'New Mexico', misc: '' },
        { key: 'NY', value: 'New York', misc: '' },
        { key: 'NC', value: 'North Carolina', misc: '' },
        { key: 'ND', value: 'North Dakota', misc: '' },
        { key: 'OH', value: 'Ohio', misc: '' },
        { key: 'OK', value: 'Oklahoma', misc: '' },
        { key: 'OR', value: 'Oregon', misc: '' },
        { key: 'PA', value: 'Pennsylvania', misc: '' },
        { key: 'RI', value: 'Rhode Island', misc: '' },
        { key: 'SC', value: 'South Carolina', misc: '' },
        { key: 'SD', value: 'South Dakota', misc: '' },
        { key: 'TN', value: 'Tennessee', misc: '' },
        { key: 'TX', value: 'Texas', misc: '' },
        { key: 'UT', value: 'Utah', misc: '' },
        { key: 'VT', value: 'Vermont', misc: '' },
        { key: 'VI', value: 'Virginia', misc: '' },
        { key: 'WA', value: 'Washington', misc: '' },
        { key: 'WV', value: 'West Virginia', misc: '' },
        { key: 'WI', value: 'Wisconsin', misc: '' },
        { key: 'WY', value: 'Wyoming', misc: '' },

    ]

}

export class Misc {
    static type: IKey[] = [
        { key: '', value: '', misc: '' },
    ];

}

export interface IDropdowns {
    value: string,
    label: string
}